import { render } from "./skip-video.vue?vue&type=template&id=73864108&ts=true"
import script from "./skip-video.vue?vue&type=script&lang=ts"
export * from "./skip-video.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__